(function () {
  var options = {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
    loopAdditionalSlides: 5,
    speed: 5000,
    autoplay: { delay: 0, disableOnInteraction: false },
    allowTouchMove: false,
  };

  function initUspMarquee() {
    var el = document.querySelector('.uspslider');
    if (!el || typeof Swiper === 'undefined') return;
    if (el.swiper && el.swiper.params.slidesPerView === 'auto') return;
    if (el.swiper) el.swiper.destroy(true, true);
    new Swiper(el, options);
  }

  window.addEventListener('load', initUspMarquee);
  setTimeout(initUspMarquee, 1000);
  setTimeout(initUspMarquee, 3000);
})();